module.exports = __webpack_public_path__ + "media/nature-vs-humans.38b7f129.mp3";